<template>
    <div>
        <div class="wrapper">

            <dashboard-navigation :myProps="fullname"></dashboard-navigation>
            <dashboard-sidebar :myProp="fullname"></dashboard-sidebar>
            <div class="content-wrapper">
                <!-- Content Header (Page header) -->
                <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Settings</h1>
                        <br />
                    </div>
                    <!--
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                        <li class="breadcrumb-item"><router-link to="/myescrow/welcome">Dashboard</router-link></li>
                        <li class="breadcrumb-item active">Settings</li>
                        </ol>
                    </div>
                    -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
                </div>
                <!-- /.content-header -->

                <!-- Main content -->
                <!-- Main content -->
                <section class="content">
                    <div class="container-fluid">
                        <!-- /.row -->
                        <br />
                        <div class="row">
                        <div class="col-12 col-sm-12 col-md-8">
                            <div class="callout callout-info">
                                <br />
                        
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label for="refunds">Settlement at Rejection</label>
                                            <p>
                                            <small>Action to be taken If Buyer Rejects and DeliveryMan Confirms Possession of Product. Note Transaction Charges Still Apply.</small>
                                            </p>
                                            <select v-model="refunds" class="form-control">
                                            <option disabled value="">Please select one</option>
                                                <option value="0">Pay Seller</option>
                                                <option value="1">Refund Buyer</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                               
                                <br />
                                <p class="text-right"><button class="btn btn-primary" style="padding:7px 40px;" v-on:click="updateDeliveryTerms">Save</button></p>
                                <br /><br />
                            </div>
                        </div>
                        <div class="col-md-4"></div>
                        </div>
                        <br />

                    </div><!--/. container-fluid -->
                </section>
                <!-- /.content -->
            </div>
            <dashboard-footer></dashboard-footer>
            
        </div>
    </div>
</template>

<style>
.no-underline{
    text-decoration: none !important;
}
</style>


<script>
const endpoint = 'http://18.208.164.251/api';

export default {
    data(){
        return{
            order_code: "",
            fullname: "",
            cancellation_sla: 0,
            logistics_fee: 0,
            refunds: "",
            errorMessage: "",
            willEdit: false,
            termId: 0,
            maximum: "7 Days",
        };
    },
    created(){

        var user_role = this.$session.get('stanbic_trustpay_user_role');

        var deliveryTermsEndpoint = endpoint +'/seller/terms';

        this.$http.get(deliveryTermsEndpoint,
        { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
        .then( 
            response => { //success
                return response.json();
            }, 
            response => { //error
                this.$router.push('/login');
            }
        )
        .then(terms => { 
                if(terms.status == "success" && terms.message == "seller_terms"){
                    console.log(terms);
                    if(terms.data.length > 0){
                        this.willEdit = true;
                        // this.termId = terms.data[0].id;
                        console.log("ID - "+this.termId);

                        // this.cancellation_sla = terms.data[0].SLA;
                        // this.logistics_fee = terms.data[0].logistics_fee;
                        this.refunds = terms.data[0].refundable_flag;
                        //this.termId = terms.data
                    }
                }else{
                    console.log("error");
                    console.log(terms);
                    //this.$router.push('/myescrow/orders');
                }
            }
        );
        
    },
    methods:{
        hideAlert: function(){
           $(".alert").addClass("d-none"); 
        },
        updateDeliveryTerms: function(){

            var result = this.validateCredentials();
            if(result != null){
                console.log(result);
                this.errorMessage = result;
                this.hideAlert();
                $(".alert-danger").removeClass("d-none"); 
                return;
            }

            console.log("flag");
            console.log(this.refunds);

            var deliveryTermsEndpoint = "/seller/term/create";

            if(this.willEdit == true){
                deliveryTermsEndpoint = "/seller/term/edit/"+this.termId;
                this.$http.put( endpoint + deliveryTermsEndpoint, 
                    {
                        "body" : "Seller Delivery Term",
                        // "SLA" : this.cancellation_sla,
                        // "logistics_fee" : this.logistics_fee,
                        "refundable_flag" : this.refunds,

                    }, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') }})
                .then( 
                    response => { //success
                        return response.json();
                    }, 
                    response => { //error
                        console.log("term add Err");
                        return response.json();
                    }
                )
                .then(term => { 
                    console.log("term add details");
                    console.log(term);
                    if(term.status == "success" && term.message == "updated_successfully"){
                        this.hideAlert();
                        this.willEdit = true;
                        $(".alert-success").removeClass("d-none");
                    }else{
                        this.errorMessage = "Something went wrong. Cannot update term at this time";
                        this.hideAlert();
                        $(".alert-danger").removeClass("d-none"); 
                        //this.$session.destroy();
                        //this.$router.push('/login');
                    }
                    
                    }
                );
            }else{

                this.$http.post( endpoint + deliveryTermsEndpoint, 
                    {
                        "body" : "Seller Delivery Term",
                        // "SLA" : this.cancellation_sla,
                        // "logistics_fee" : this.logistics_fee,
                        "refundable_flag" : this.refunds,

                    }, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') }})
                .then( 
                    response => { //success
                        return response.json();
                    }, 
                    response => { //error
                        console.log("term add Err");
                        return response.json();
                    }
                )
                .then(term => { 
                    console.log("term add details");
                    console.log(term);
                    if(term.status == "success" && term.message == "term_added"){
                        this.hideAlert();
                        this.willEdit = true;
                        $(".alert-success").removeClass("d-none");
                    }else{
                        this.$session.destroy();
                        this.$router.push('/login');
                    }
                    
                    }
                ); 
            }
        },
        validateCredentials(){

        //     if(isNaN(this.cancellation_sla) || this.cancellation_sla < 0 || this.cancellation_sla > 24) {
        //         return "Please enter a positive number less than 24 hours for cancellation sla";
        //     }

        //     if(isNaN(this.logistics_fee) || this.logistics_fee < 0 || this.logistics_fee > 10) {
        //         return "Please enter a positive percentage less than 10 for logistics fee";
        //     }

        //     if(this.refunds == "" || this.refunds == null) {
        //         return "Please choose a refund action";
        //     }

        //     return null;
        },

    },
    beforeCreate: function () {
        console.log(this.$session.get('trustpayauthtoken'));

        var userDetailsEndpoint = endpoint +'/customer';

        if(this.$session.get('stanbic_trustpay_user_role') == "seller"){
            userDetailsEndpoint = endpoint +'/seller/account';
        }

        this.$http.get(userDetailsEndpoint, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
            .then( 
                response => { //success
                    return response.json();
                }, 
                response => { //error
                    this.$router.push('/login');
                }
            )
            .then(user => { 
                if(user.status == "success" && user.message == "customer_details"){
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    console.log("stats "+this.status);
                }else if (user.status == "success" && user.message == "seller_details"){
                    
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    console.log("stats "+this.status);

                    if(user.data.verified == 0){
                        this.$router.push('/myescrow/verify');
                    }

                }else{
                    alert("Your session has timed out. Please login again");
                    this.$session.destroy();
                    this.$router.push('/login');
                    //this.$router.push('/login');
                }
                
                }
            );

    
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/settings.vue